"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scenario_state_1 = require("./scenario.state");

var joi_1 = __importDefault(require("@hapi/joi"));

exports.pipeNodeMap = function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (nodeMap) {
    return fns.reduce(function (v, fn) {
      return fn(v);
    }, nodeMap);
  };
};

exports.handleUpdateNode = function (id) {
  for (var _len2 = arguments.length, handlers = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    handlers[_key2 - 1] = arguments[_key2];
  }

  return function (nodeMap) {
    var _exports;

    var node = nodeMap[id];
    if (!node) throw new Error("node with given id does not exist !!!! id >>> ".concat(id));
    return _objectSpread({}, nodeMap, _defineProperty({}, id, (_exports = exports).pipeNode.apply(_exports, handlers)(node)));
  };
};

exports.handleRemoveNode = function (id) {
  return function (nodeMap) {
    var clone = _objectSpread({}, nodeMap);

    delete clone[id];
    return clone;
  };
};

exports.handleMergeNodeMap = function (anotherNodeMap) {
  return function (nodeMap) {
    return _objectSpread({}, nodeMap, {}, anotherNodeMap);
  };
};
/* node
---------------------------------------*/

/* init */


exports.initNode = function (header, parentId, type) {
  return {
    header: header,
    parentId: parentId,
    type: type,
    options: []
  };
};

exports.pipeNode = function () {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }

  return function (node) {
    return fns.reduce(function (n, fn) {
      return fn(n);
    }, node);
  };
};

exports.handleSetHeader = function (header) {
  return function (node) {
    return _objectSpread({}, node, {
      header: header
    });
  };
};

exports.handleSetParentId = function (parentId) {
  return function (node) {
    return _objectSpread({}, node, {
      parentId: parentId
    });
  };
};

exports.handleUpdateOptions = function () {
  for (var _len4 = arguments.length, optionsHandlers = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    optionsHandlers[_key4] = arguments[_key4];
  }

  return function (node) {
    var _exports2;

    var clone = _objectSpread({}, node);

    clone.options = (_exports2 = exports).pipeOptions.apply(_exports2, optionsHandlers)(node.options);
    return clone;
  };
};

exports.pipeOptions = function () {
  for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    fns[_key5] = arguments[_key5];
  }

  return function (options) {
    return fns.reduce(function (o, fn) {
      return fn(o);
    }, options);
  };
};

exports.handleUpdateOption = function (index) {
  for (var _len6 = arguments.length, handlers = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    handlers[_key6 - 1] = arguments[_key6];
  }

  return function (options) {
    return options.map(function (option, i) {
      var _exports3;

      return i === index ? (_exports3 = exports).pipeOption.apply(_exports3, handlers)(option) : option;
    });
  };
};

exports.handlePushOption = function (option) {
  return function (options) {
    return [].concat(_toConsumableArray(options), [option]);
  };
};

exports.handleRemoveOption = function (index) {
  return function (options) {
    return options.filter(function (_, i) {
      return i !== index;
    });
  };
};

exports.handleMoveOption = function (fromIndex, toIndex) {
  return function (options) {
    if (fromIndex === toIndex) return options;

    var isValidIndex = function isValidIndex(index) {
      return 0 <= index && index <= options.length - 1;
    };

    if (!isValidIndex(fromIndex) || !isValidIndex(toIndex)) return options;

    var clone = _toConsumableArray(options);

    var _clone$splice = clone.splice(fromIndex, 1),
        _clone$splice2 = _slicedToArray(_clone$splice, 1),
        removedOption = _clone$splice2[0];

    clone.splice(toIndex, 0, removedOption);
    return clone;
  };
};
/* option
---------------------------------------*/

/* init */


exports.initTextOption = function (label) {
  return {
    actionType: null,
    actionId: null,
    actionUrl: null,
    label: label
  };
};

exports.initImageOption = function (imageName, imageUrl) {
  return {
    actionType: null,
    actionId: null,
    actionUrl: null,
    imageName: imageName,
    imageUrl: imageUrl
  };
};

exports.initImageExplanationOption = function (imageName, imageUrl, explanation) {
  return {
    actionType: null,
    actionId: null,
    actionUrl: null,
    imageName: imageName,
    imageUrl: imageUrl,
    explanation: explanation
  };
};

exports.pipeOption = function () {
  for (var _len7 = arguments.length, fns = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    fns[_key7] = arguments[_key7];
  }

  return function (option) {
    return fns.reduce(function (o, fn) {
      return fn(o);
    }, option);
  };
};

exports.handleResetActionType = function () {
  return function (option) {
    return _objectSpread({}, option, {
      actionType: null,
      actionId: null,
      actionUrl: null
    });
  };
};

exports.handleSetActionId = function (actionId) {
  return function (option) {
    return _objectSpread({}, option, {
      actionType: scenario_state_1.ActionType.Id,
      actionId: actionId,
      actionUrl: null
    });
  };
};

exports.handleSetActionUrl = function (actionUrl) {
  return function (option) {
    return _objectSpread({}, option, {
      actionType: scenario_state_1.ActionType.Url,
      actionUrl: actionUrl,
      actionId: null
    });
  };
};

exports.handleSetLabel = function (label) {
  return function (option) {
    return _objectSpread({}, option, {
      label: label
    });
  };
};

exports.handleSetImageName = function (imageName) {
  return function (option) {
    return _objectSpread({}, option, {
      imageName: imageName
    });
  };
};

exports.handleSetImageUrl = function (imageUrl) {
  return function (option) {
    return _objectSpread({}, option, {
      imageUrl: imageUrl
    });
  };
};

exports.handleSetExplanation = function (explanation) {
  return function (option) {
    return _objectSpread({}, option, {
      explanation: explanation
    });
  };
};
/* verificatoin
---------------------------------------*/


exports.existNode = function (nodeMap, nodeId) {
  return !!nodeMap[nodeId];
};

exports.existOption = function (node, optionIndex) {
  return !!node.options[optionIndex];
};

exports.existNodeAndOption = function (nodeMap, nodeId, optionIndex) {
  return exports.existNode(nodeMap, nodeId) && exports.existOption(nodeMap[nodeId], optionIndex);
};

exports.verifyNodeType = function (nodeMap, nodeId, type) {
  var node = nodeMap[nodeId];
  return !!node && node.type === type;
};
/* find
---------------------------------------*/


exports.findParentOptionIndex = function (nodeMap, nodeId, parentNodeId) {
  var options = nodeMap[parentNodeId].options;
  return options.findIndex(function (option) {
    return option.actionId === nodeId;
  });
};
/*====================================
  Variable
=====================================*/


exports.extractKey = function (rawKey) {
  var res = rawKey.match(/\$\{([^${}\s]+)\}/);
  return res ? res[1] : undefined;
};

exports.parseText = function (rawText, variables) {
  if (variables.length === 0) return rawText;
  var texts = rawText.split(/\$\{([^${}\s]+)\}/);
  return texts.map(function (text) {
    var variable = variables.find(function (v) {
      return v.key === text;
    });
    return !variable ? text : variable.value;
  }).join('');
}; // 存在しない urlVariable を指定していた場合は エラー throw


exports.parseUrl = function (urlVariableKey, urlVariables) {
  var variable = urlVariables.find(function (variable) {
    return variable.key === urlVariableKey;
  });
  if (!variable) throw new Error("Invalid urlVariableKey is given !!! urlVariableKey >>>> ".concat(urlVariableKey));
  return variable.value;
};
/*====================================
  DEPLOY SCENARIO
=====================================*/

/* parse
---------------------------------------*/


exports.parseActinUrl = function (rawActionUrl, variables) {
  if (!rawActionUrl) return null;
  var urlVariableKey = exports.extractKey(rawActionUrl);
  if (!urlVariableKey) return rawActionUrl;
  return exports.parseUrl(urlVariableKey, variables.filter(function (_ref) {
    var type = _ref.type;
    return type === scenario_state_1.VariableType.Url;
  }));
};

exports.parseNode = function (node, variables) {
  if (node.type === scenario_state_1.ScenarioNodeType.Greeting) return exports.parseGreetingScenarioNode(node, variables);
  if (node.type === scenario_state_1.ScenarioNodeType.Text) return exports.parseTextScenarioNode(node, variables);
  if (node.type === scenario_state_1.ScenarioNodeType.Image) return exports.parseImageScenarioNode(node, variables);
  if (node.type === scenario_state_1.ScenarioNodeType.ImageExplanation) return exports.parseImageExplanationScenarioNode(node, variables);
  return node;
};

exports.parseGreetingScenarioNode = function (node, variables) {
  var clone = _objectSpread({}, node);

  clone.options = node.options.map(function (option) {
    return _objectSpread({}, option, {
      actionUrl: exports.parseActinUrl(option.actionUrl, variables)
    });
  });
  return clone;
};

exports.parseTextScenarioNode = function (node, variables) {
  var clone = _objectSpread({}, node);

  clone.header = exports.parseText(node.header, variables);
  clone.options = node.options.map(function (option) {
    return _objectSpread({}, option, {
      label: exports.parseText(option.label, variables),
      actionUrl: exports.parseActinUrl(option.actionUrl, variables)
    });
  });
  return clone;
};

exports.parseImageScenarioNode = function (node, variables) {
  var clone = _objectSpread({}, node);

  clone.options = node.options.map(function (option) {
    return _objectSpread({}, option, {
      imageName: exports.parseText(option.imageName, variables),
      actionUrl: exports.parseActinUrl(option.actionUrl, variables)
    });
  });
  return clone;
};

exports.parseImageExplanationScenarioNode = function (node, variables) {
  var clone = _objectSpread({}, node);

  clone.options = node.options.map(function (option) {
    return _objectSpread({}, option, {
      imageName: exports.parseText(option.imageName, variables),
      explanation: exports.parseText(option.explanation, variables),
      actionUrl: exports.parseActinUrl(option.actionUrl, variables)
    });
  });
  return clone;
};

exports.parseNodeMap = function (nodeMap, variables) {
  var clone = _objectSpread({}, nodeMap);

  Object.keys(clone).forEach(function (nodeId) {
    clone[nodeId] = exports.parseNode(nodeMap[nodeId], variables);
  });
  return clone;
};
/* validation
---------------------------------------*/


exports.validateUrl = function (url) {
  var schema = joi_1.default.string().uri().required();

  var _schema$validate = schema.validate(url),
      error = _schema$validate.error;

  return !error;
};

exports.getValidateAction = function (validateActionId, validateActionUrl) {
  return function (_ref2) {
    var actionType = _ref2.actionType,
        actionId = _ref2.actionId,
        actionUrl = _ref2.actionUrl;
    var hasNoAction = !actionType && !actionId && !actionUrl;
    var isValidActionId = actionType === scenario_state_1.ActionType.Id && !!actionId && validateActionId(actionId);
    var isValidActionUrl = actionType === scenario_state_1.ActionType.Url && !!actionUrl && validateActionUrl(actionUrl);
    return hasNoAction || isValidActionId || isValidActionUrl;
  };
};

exports.getValidateNode = function (validateAction) {
  return function (node) {
    var options = node.options;
    var isTextNodeWithoutOptions = node.type === scenario_state_1.ScenarioNodeType.Text && options.length === 0;
    var hasOptions = options.length > 0;
    var isValidOptions = options.every(function (option) {
      return validateAction(option);
    });
    return isTextNodeWithoutOptions || hasOptions && isValidOptions;
  };
};

exports.validateNodeTree = function (nodeMap, topNodeId, validateNode) {
  var topNode = nodeMap[topNodeId];
  if (!topNode) throw new Error("Node with given top node id does not exist in nodeMap!!! topNodeId >>> ".concat(topNodeId));
  var validatedNodeIdMap = {};

  var doValidate = function doValidate(node) {
    if (!validateNode(node)) return false;
    var isValidChildren = true;
    var options = node.options;
    options.forEach(function (_ref3) {
      var actionId = _ref3.actionId;
      if (!isValidChildren) return;
      if (!actionId) return;
      if (validatedNodeIdMap[actionId]) return; // 同一のnodeは一度のみ validation し、ループ回避

      validatedNodeIdMap[actionId] = true;
      isValidChildren = nodeMap[actionId] && doValidate(nodeMap[actionId]);
    });
    return isValidChildren;
  };

  return doValidate(topNode);
};
/**
 * [INVALID CASE]
 *  - テキストシナリオノードで、かつ選択肢がない (node.type === ScenarioNodeType.Text && options.length === 0)
 *  - IDアクションなのに、次の node が存在しない (option.actionType === ActionType.Id && !nodeMap[nextNodeId])
 *  - URLアクションなのに、url が無効な値 (option.actionType === ActionType.Url && !isValidUrl(url))
 *
 * その他に関しては、それぞれの input で validation 対応済みの想定
 */


exports.validateNodeMap = function (nodeMap, topNodeId) {
  var validteActionId = function validteActionId(actionId) {
    return !!nodeMap[actionId];
  };

  var validateAction = exports.getValidateAction(validteActionId, exports.validateUrl);
  var validateNode = exports.getValidateNode(validateAction);
  return exports.validateNodeTree(nodeMap, topNodeId, validateNode);
};